import * as Constants from './Constants';

const initialState = {
  status: false,
  cart: {},
  depletionType: '',
  shipment: {},
  payment: {},
  smsEnabledDevice: {},
  validateOrderDetails: {},
  orderDetails: {},
  lineDetails: {},
  cartHeader: {},
  getCheckoutResponse: {},
};

function getCheckOutDetails(state = initialState, action) {
  switch (action.type) {
    case Constants.GET_CHECKOUT_DETAILS_SUCCESS:
      return { ...state, status: action.response };

    case Constants.GET_CHECKOUT_DETAILS_RESPONSE:
      return {
        ...state,
        status: true,
        getCheckoutResponse: action.response,
        cart: action.response?.data?.cart || {},
        orderDetails: action.response?.data?.cart?.orderDetails || {},
        lineDetails: action.response?.data?.cart?.lineDetails || {},
        cartHeader: action.response?.data?.cart?.cartHeader || {},
        depletionType: action.response?.data?.cart?.lineDetails?.lineInfo?.newLine1?.deviceItem?.depletionType || '',
        shipment: action.response?.data?.shipment || {},
        payment: action.response?.data?.payment || {},
        smsEnabledDevice: action.response?.data?.smsEnabledDevice || {},
        validateOrderDetails: action.response?.data?.validateOrderDetails || {},
      };

    default:
      return state;
  }
}

export default getCheckOutDetails;
